import React from "react";

import { Description, ModalBody, Title } from "./styles";

export function ConfirmContractGenerationStep({ solicitationId }) {
	return (
		<ModalBody>
			<Title>
				Gerar contrato a partir da solicitação #
				{solicitationId?.padStart(6, "0")}
			</Title>
			<Description>
				O contrato será criado no sistema, ficará disponível na lista de
				contratos e também poderá ser acessado através da solicitação.
			</Description>
		</ModalBody>
	);
}
